<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>工资审核管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <!-- RefundSystem card header area -->
      <el-row>
        <el-col style="text-align:left;" :span="8">
          <el-button type="primary" size="small" @click="Refresh" plain
            >刷新</el-button
          >
        </el-col>

        <el-col style="text-align:right;" :span="14">
          <el-button
            type="danger"
            class="danger"
            size="small"
            @click="updatePwd"
            plain
            >修改登录密码</el-button
          >
        </el-col>

        <el-col
          style="text-align: right;"
          :span="2"
          v-show="isShowSend"
        >
          <el-button type="primary" class="primary" @click="updownResult"
            >导入结果</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" style="width: 100%" size="small">
            <el-table-column prop="date" label="年" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.Years }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="月" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.Months }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="公司">
              <template slot-scope="scope">
                <span>{{ scope.row.Company_Name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="版本">
              <template slot-scope="scope">
                <span>{{ scope.row.Editions }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="状态">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.KPIType == 1
                      ? "财务已核对，待CEO审核"
                      : scope.row.KPIType == 2
                      ? "CEO已审核，待董事长同意"
                      : scope.row.KPIType == 3
                      ? "CEO已审核，待财务发放"
                      : scope.row.KPIType == 4
                      ? "财务已发放"
                      : scope.row.KPIType == 5
                      ? "财务核对不通过"
                      : scope.row.KPIType == 6
                      ? "CEO审核不通过"
                      : scope.row.KPIType == 7
                      ? "董事长审核不通过"
                      : "人资已添加，待财务核对"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="驳回原因">
              <template slot-scope="scope">
                <span>{{ scope.row.BecauseOf }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click="lookdetail(scope.row)"
                  >查看详情</el-button
                >
                <!-- <el-button
                  type="text"
                  size="mini"
                  @click="handleDelete(scope.$index, scope.row)"
                  >查看修改</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="text-align:right;" :span="24">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float:right"
          ></el-pagination>
        </el-col>
      </el-row>
      <el-dialog
        width="50%"
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        top="10px"
      >
        <el-form :model="pass" ref="taskForm">
          <el-form-item label="旧密码" :label-width="formLabelWidth">
            <el-input
              v-model="pass.oldpassword"
              autocomplete="off"
              show-password
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" :label-width="formLabelWidth">
            <el-input
              v-model="pass.newpassword"
              autocomplete="off"
              show-password
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" :label-width="formLabelWidth">
            <el-input
              v-model="pass.newrepassword"
              autocomplete="off"
              show-password
              placeholder="请确认密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="savePwd">保存</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="upTitle" :visible.sync="upDialog" width="40%">
        <h5>说明：</h5>
        <p>1、请严格按照模板格式进行填写数据，否则可能导入失败；</p>
        <p>2、填写的数据中不可出现空格和换行符；</p>
        <p>3、填写的邮箱，手机和信用证号确定存在，否则导入失败。</p>
        <div class="upbox">
          <h5>选择EXCEL文件：</h5>
          <!-- <input type="file" id="file" /> -->
          <el-upload
            class="upload-demo"
            action="http://hr.text.ruizhiqi.com/publicApi/Exported/UploadImportFile"
            name="file_head"
            :limit="1"
            :file-list="fileList"
            accept=".xls,.xlsx"
            :on-success="handleChangeUpload"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary" class="upbtn"
              >选择文件</el-button
            >
          </el-upload>
          <br />
          <el-button
            size="small"
            type="primary"
            v-if="fileName != ''"
            style="float:none;margin:30px 0 0 100px;"
            @click="goUp"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { cryptoDecode } from "../../until/encrypt.js";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import {
  GetInfoList,
  UpdateSecondPwd
} from "../../until/ZeusApiSDK/Logic/SalaryInfoLogic";
export default {
  data() {
    return {
      tableData: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      dialogTitle: "修改密码",
      currentRole: {}, //获取当前用户角色
      dialogVisible: false,
      isShowSend: false,
      upTitle: "",
      upDialog: false,
      files: {},
      fileName: "",
      filedata: {
        name: "file_head"
      },
      fileList: [],
      fileraw: {},
      pass: {
        oldpassword: "",
        newpassword: "",
        newrepassword: ""
      },
      formLabelWidth: "120px"
    };
  },
  //亚敏进入加载方法
  created() {
    //获取当前用户
    this.getCurrentUser();
    //获取当前用户角色
    this.getCurrentRole();
    this.GetInfoList();
  },
  methods: {
    //获取当前用户
    getCurrentUser: function() {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取当前用户角色
    getCurrentRole: function() {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      this.currentRole = JSON.parse(Decrypt(currentUserRole));
      console.log(this.currentRole.Key);
      if (this.currentRole.Key == "SalaryHR") {
        this.isShowSend = true;
      }
    },
    //获取列表API
    GetInfoList: async function() {
      this.loading = true;
      await GetInfoList(this.pageIndex, this.pageSize).then(res => {
        this.loading = false;
        this.tableData = res.Data.DataList;
        this.totalCount = res.Data.totalCount;
      });
    },
    //方法区域
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetInfoList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetInfoList();
    },
    //刷新页面
    Refresh: function() {
      this.GetInfoList();
    },
    //打开密码输入页面
    updatePwd: function() {
      this.dialogVisible = true;
    },
    //保存密码
    savePwd: function() {
      if (this.pass.newrepassword == this.pass.newpassword) {
        this.$message({
          showClose: true,
          message: "修改密码失败，确认密码与新密码不一致！",
          type: "error"
        });
      } else {
        if (this.pass.oldpassword == this.pass.newpassword) {
          this.$message({
            showClose: true,
            message: "修改密码失败，新密码与旧密码一致！",
            type: "error"
          });
        } else {
          UpdateSecondPwd(
            this.currentUser.UserCode,
            this.pass.oldpassword,
            this.pass.newpassword
          ).then(res => {
            console.log(res);
            if (res.Code == 1) {
              var msg = this.$message({
                showClose: true,
                message: "修改成功",
                type: "success"
              });
              msg.close();
            } else {
              this.$message({
                showClose: true,
                message: "修改失败",
                type: "error"
              });
            }
          });
          // console.log("this.pass", this.pass);
        }
      }
    },
    //查看详情
    lookdetail: function(data) {
      this.$router.push("/salaryinfo/SalaryDetail?pid=" + data.Id);
    },
    updownResult: function() {
      this.upTitle = "批量导入工资结果";
      this.upDialog = true;
    },
    // 上传前检测
    beforeUpload(file) {
      this.files = file;
      console.log(file);
      const extension = file.name.split(".")[1] === "xls";
      const extension2 = file.name.split(".")[1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!extension && !extension2) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        return;
      }
      if (!isLt2M) {
        this.$message.warning("上传模板大小不能超过 5MB!");
        return;
      }
      this.fileName = file.name;
      // return false; // 返回false不会自动上传
    },
    handleChangeUpload(res) {
      // console.log(res);
      this.fileraw = res.Message;
    }, 
    goUp() {
      if (this.fileName == "") {
        this.$message.warning("请选择要上传的文件！");
        return false;
      }
      var userinfo = JSON.parse(
        cryptoDecode(window.sessionStorage.getItem("userinfo"))
      );
      var UserId = userinfo.UserId;
      console.log(UserId);
      console.log(this.currentUser.UserCode);
       $.ajax({
          url:
            "http://hr.text.ruizhiqi.com/publicApi/SalaryResult/OffLineImportSave?path=" +
            this.fileraw +
            "&userId=" +
            UserId+"&userCode="+this.currentUser.UserCode,
          type: "POST",
          async: false,
          contentType: "application/x-www-form-urlencoded",
          Accept: "application/json",
          success: function(res) {
            console.log(res);
            alert(res.Message);
          },
          
        });
    }
  }
};
</script>